import { EntitlementsProject } from '@adsk/alloy-provider';

export function getSelectedProduct(
  project: EntitlementsProject,
  selectedProductId?: string,
) {
  const selectedProduct = project.products?.find(
    (product) => product.key === selectedProductId,
  );
  const defaultProduct = project.products?.find(
    (product) => product.defaultUrl === project.defaultUrl,
  );
  const firstProduct = project.products[0];

  return selectedProduct || defaultProduct || firstProduct;
}
